import * as React from 'react';

import * as styles from './pageTop.css';

export const OfferCardPageLayoutTop = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['top']}>{props.children}</div>;
};
